import React, { useEffect, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import cn from "classnames";
import { supportsShadowDOM } from "lib/shadowDOM";
import { CSS_COMPONENT_PREFIX } from "config";
import { featureFlagState } from "state";
import { ConfigProvider } from "hooks/useConfig";
import { GTMProvider } from "hooks/useGTM";
import { ModalProvider } from "hooks/useModal";
import useResizeObserver from "hooks/useResizeObserver";
import GlobalModal from "components/ui/GlobalModal";
import Tabs from "components/Tabs";

const Widget = configArgs => {
  const { id, vertical, enableBestFareFinderAndRecentOrders } = configArgs;

  const setFeatureFlags = useSetRecoilState(featureFlagState);
  const widgetNodeRef = useRef();
  const [height, setHeight] = useState(0);
  const [CSSloaded, setCSSloaded] = useState(false);
  const [modalHeight, setModalHeight] = useState(0);

  const onResize = ({ height }) => {
    setHeight(height);
  };

  useEffect(() => {
    if (widgetNodeRef.current) {
      if (supportsShadowDOM()) {
        // fetching external CSS for Shadow DOMz
        const shadowCSS = document.querySelector('[data-id="jpWidgetCSS"]').cloneNode(true);
        widgetNodeRef.current.appendChild(shadowCSS);
        const otrlUICSSNode = document.querySelector('[data-id="otrlUICSS"]');
        if (otrlUICSSNode) {
          widgetNodeRef.current.appendChild(otrlUICSSNode.cloneNode(true));
        }
        setCSSloaded(true);
      } else {
        setCSSloaded(true);
      }
    }
  }, [widgetNodeRef]);

  useEffect(() => {
    const { featureFlags } = configArgs;
    setFeatureFlags(featureFlags);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useResizeObserver({ id, element: widgetNodeRef.current, onResize });

  // Make the config querable in the JavaScript console
  window[`otrlJPWidgetConfig${id.replace(/[^a-z0-9]/gi, "")}`] = configArgs;

  const baseClass = CSS_COMPONENT_PREFIX + 'widget';
  const classes = cn(baseClass, {
    [`${baseClass}--vertical`]: vertical,
    "otrl-ui__widget--vertical": vertical
  });

  return (
    <ConfigProvider config={configArgs}>
      <ModalProvider>
        <GTMProvider eventPrefix={vertical ? 'OTRL:JPWidget:' : 'OTRL:JPHorizontalWidget:'}>
          <div
            className={classes}
            style={{ height: modalHeight ? `${modalHeight}px` : "auto" }}
            ref={widgetNodeRef}
          >
            {CSSloaded && (
              <React.Fragment>
                <Tabs />
                <GlobalModal height={height} setModalHeight={setModalHeight} />
              </React.Fragment>
            )}
          </div>
        </GTMProvider>
      </ModalProvider>
    </ConfigProvider>
  );
};

export default Widget;
